module.exports = __webpack_public_path__ + "./fonts/lato-light-webfont.woff";


//////////////////
// WEBPACK FOOTER
// ./Content/fonts/lato-light-webfont.woff
// module id = 20
// module chunks = 0